import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { IRepresentantsDto } from "@/Common/Api/Patient/Dto/IRepresentantsDto";
import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

class PatientEmailValidator {
    public Representants: IRepresentantsDto;

    constructor(representants: IRepresentantsDto) {
        this.Representants = representants;
    }

    public get PatientIsOfLegalAgeOfConsent(): boolean {
        return !this.Representants.Patient.DateOfBirth || PatientHelper.getPatientIsOfAgeOfConsent(this.Representants.Patient.DateOfBirth);
    }

    public get PatientHasValidEmail(): boolean {
        if (this.PatientIsOfLegalAgeOfConsent)
            return this.Representants.PatientEmails?.any(email => ValidationHelper.isExactMatch(email.Address, ValidationHelper.emailRegex)) ?? false;
        else
            return this.Representants.Representants
                .any(item => item.Emails.any(email => ValidationHelper.isExactMatch(email.Address, ValidationHelper.emailRegex)));
    }

    public get PatientHasRepresentant(): boolean {
        return !this.PatientIsOfLegalAgeOfConsent && this.Representants.Representants.any();
    }

    public get PatientHasRepresentantWithValidContact(): boolean {
        if (!this.PatientIsOfLegalAgeOfConsent && !this.Representants.Representants.any())
            return false;

        let hasValidEmail = this.Representants.Representants
            .any(item => item.Emails.any(email => ValidationHelper.isExactMatch(email.Address, ValidationHelper.emailRegex)));

        return cacheStore.portalConfiguration?.HasSmsNotificationEnabled
            ? !this.PatientIsOfLegalAgeOfConsent && (hasValidEmail || this.Representants.Representants.any(item => item.PhoneNumbers?.any(phone => PhoneNumber.validatePhone(phone))))
            : !this.PatientIsOfLegalAgeOfConsent && hasValidEmail;
    }
}

export { PatientEmailValidator };
